import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getProduct } from "../actions/productActions";
import { generateStockWithPrice, ResetSelectedStock } from "../actions/stockActions";
import "react-image-gallery/styles/css/image-gallery.css";
import PoductInfo from "../components/PoductInfo";
import ImageViewer from "../components/ImageViewer";
import ProductVariations from "../components/ProductVariations";
import ProductBundleOptions from "../components/ProductBundleOptions";
import SocialShare from "../components/SocialShare";
import PoductTabs from "../components/PoductTabs";
import CartActions from "../containers/CartActions";
import ProductsSlider from "../containers/ProductsSlider";
import { withRouter } from "react-router";
import _ from "lodash";
import ProductPrice from "../components/ProductPrice";
import ArticleNumber from "../components/ArticleNumber";
import { withTranslation } from 'react-i18next';
import Alert from "../components/Alert";
import { utils } from "../common/utils";
import ExtendedLink from "../components/ExtendedLink";
import { ProductTypeEnum } from '../common/enums';

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockItemId: 0,
            selectedVariationsIds: "",
            quantity: 1,
            originalPrice: 0,
            specialPrice: 0,
            productId: 0,
            stockItemCode: "",
            hasVariationChanged: false,
            isProductNotFound: false
        };

        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onAllProductOptionsSelected = this.onAllProductOptionsSelected.bind(this);
    }

    componentDidMount() {
        const id = parseInt(this.props.match.params.id, 10);
        if (this.state.productId !== id) {
            this.loadProduct(id);
        }
    }


    componentDidUpdate(prevProps) {
        //const product = this.props.selectedProduct;
        const nextProductId = parseInt(this.props.match.params.id, 10);
        if (this.state.productId !== nextProductId) {
            this.loadProduct(nextProductId);
        }
    }

    loadProduct(id) {
        this.setState({ productId: id });
        this.props.getProduct(id).then((response) => {
           // console.log(response);
            if (response) {
                const product = response.value.data;
                this.setState({
                   // productId: product.id,
                    stockItemId: product.stockItemId,
                    selectedVariationsIds: "",
                    quantity: this.state.quantity,
                    originalPrice: product.originalPrice,
                    stockItemCode: product.stockItemCode,
                    specialPrice: product.specialPrice,
                    isProductNotFound: false
                });

                this.fireMarketingEvents(product);
            } else {
                this.setState({
                  //  productId: id,
                    isProductNotFound: true
                });
            }

        }, (error) => {

        });
    }

    fireMarketingEvents = (product) => {
        const { settings } = this.props;
        if (window.fbq) {
            window.fbq('track', 'ViewContent',
                {
                    currency: settings.isoCurrencySymbol,
                    content_type: 'product',
                    value: product.specialPrice,
                    contents: [{
                        id: product.stockItemCode,
                        quantity: this.state.quantity
                    }]

                });
        }

        if (window.gtag) {
            window.gtag('event', 'view_item', {
                currency: settings.isoCurrencySymbol,
                items: [{
                    item_id: product.stockItemCode,
                    item_name: product.title,
                    item_category: product.groupName,
                    price: product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: this.state.quantity
                }],
                value: product.specialPrice
            });
        }
    };


    onQuantityChange(e) {
        this.setState({
            quantity: parseInt(e.target.value, 10)
        });
    }

    onAllProductOptionsSelected(allProductOptionsIds) {
        const { user, selectedProduct } = this.props;

        if (allProductOptionsIds) {
            this.setState({
                selectedVariationsIds: allProductOptionsIds
            });

            const params = { customerId: (user.id ? user.id : null), productId: selectedProduct.id, optionsIds: allProductOptionsIds, quantity: this.state.quantity, productType: selectedProduct.productType };
            this.props.generateStockWithPrice(params);

        } else {
            this.props.ResetSelectedStock(this.state.specialPrice, this.state.originalPrice);
        }

        this.setState({
            hasVariationChanged: !this.state.hasVariationChanged,
        });

    }

    render() {
        const { t, selectedProduct, settings } = this.props;
        const { specialPrice } = selectedProduct;
        const showOpenPay = settings.isOpenpayEnabled === true && settings.showBadgeOnProductPages && specialPrice > settings.openpayMinLimit && specialPrice < settings.openpayMaxLimit;

        if (this.state.isProductNotFound === true) // || selectedProduct.id === 0)
            return <Alert type="danger" title={t("Product Not Found")} msg={t("This product is not available. please make sure you have the correct link")} />;

        if (_.isEmpty(selectedProduct)) return <div />;

        const groupsLink = `${settings.baseUrl}categories/${selectedProduct.groupId}`;
        const quantities = [...Array(10)].map((x, i) => (
            <option key={i}>{i + 1}</option>
        ));

        const productOptionsLists = selectedProduct.productType === ProductTypeEnum.Bundle ?
            (
                <ProductBundleOptions
                    productId={selectedProduct.id}
                    combinations={selectedProduct.combinations}
                    onAllProductOptionsSelected={this.onAllProductOptionsSelected.bind(this)}
                />
            ) :
            (<ProductVariations productId={selectedProduct.id}
                variations={selectedProduct.variations}
                variables={selectedProduct.variables}
                onAllVariationSelected={this.onAllProductOptionsSelected.bind(this)}
            />
            );
        return (
            <Fragment>
                <div className="row">
                    <ImageViewer images={selectedProduct.images} />
                    <div className="col-md-6">
                        <h2 className="padding-top-1x text-normal">
                            {selectedProduct.title}
                        </h2>
                        <ProductPrice product={selectedProduct} settings={settings} />
                        {showOpenPay && < div>
                            <opy-cart amount={specialPrice} logo="grey-on-amberbg" more-info-text={t("More info")} logo-position="right"></opy-cart>
                        </div>}
                        <ArticleNumber stockItemCode={selectedProduct.stockItemCode} />
                        <div className="padding-bottom-1x">
                            <span className="text-medium">{t("Group")}:&nbsp;</span>
                            <ExtendedLink to={groupsLink} className="navi-link">
                                {selectedProduct.groupName}
                            </ExtendedLink>
                        </div>
                        {selectedProduct.description && <div className="padding-bottom-1x">
                            <span>{selectedProduct.description}</span>

                        </div>}
                        <PoductInfo settings={settings} product={selectedProduct} />
                        {productOptionsLists}

                        {settings.isCatalogueMode !== true && <div className="row margin-top-1x quantity-container">
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label htmlFor="quantity">{t("Quantity")}</label>
                                    <select
                                        className="form-control"
                                        id="quantity"
                                        value={this.state.quantity}
                                        onChange={this.onQuantityChange}
                                    >
                                        {quantities}
                                    </select>
                                </div>
                            </div>
                        </div>}
                        <hr className="mb-3" />
                        {settings.isCatalogueMode !== true && <div className="d-flex flex-wrap justify-content-between">
                            <SocialShare
                                supplierName={settings.supplierName}
                                shape="circle"
                                showTitle={true}
                                url={`${utils.getWebshopFullUrl(settings)}products/${selectedProduct.id}`}
                                shareTitle={t('Check this amazing product')}
                            />

                            <div className="sp-buttons mt-2 mb-2">
                                <CartActions product={selectedProduct}
                                    quantity={this.state.quantity}
                                    stockItemId={selectedProduct.stockItemId}
                                    originalPrice={selectedProduct.originalPrice}
                                    specialPrice={selectedProduct.specialPrice}
                                    loyaltyPoints={selectedProduct.loyaltyPoints}
                                    isDetailsView={true} />
                            </div>
                           
                        </div>}
                            {/*{settings.isCatalogueMode === true &&*/}
                            {/*    <button className="btn btn-rounded enjo-background-color pl-2 btn-text-overflow" type="button" rel="noopener noreferrer"*/}
                            {/*        title={t("Test Your Knowledge")} href='#'>{t("Test Your Knowledge")}</button>}*/}
                    </div>
                </div>
                <PoductTabs product={selectedProduct} showCookieConsent={settings.showCookieConsent} isCatalogueMode={settings.isCatalogueMode} />
                <ProductsSlider isRelated={true} productId={selectedProduct.id} />
                <ProductsSlider isRecommended={true} productId={selectedProduct.id} />
            </Fragment>
        );
    }
}

function mapStateToProps({ selectedProduct, settings, user }, ownProps) {
    return { selectedProduct, settings, user, ...ownProps };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, { getProduct, generateStockWithPrice, ResetSelectedStock })(ProductDetails))
);
